// // import React from "react";
// // import {
// //   Bell,
// //   MessageCircle,
// //   Calendar,
// //   House,
// //   Camera,
// //   ChartColumn,
// //   Users,
// //   TrendingUp,
// //   Zap,
// //   GitMerge,
// //   Settings,
// //   CheckCircle2,
// //   Clock,
// //   BarChart3,
// //   UserCheck,
// //   Rocket,
// // } from "lucide-react";
// // import RealEsatteImage from "../../assets/realestate.jpg";
// // import { Helmet } from "react-helmet-async";

// // const RealEstate = () => {
// //   const leadManagementFeatures = [
// //     {
// //       title: "Smart Lead Capture & Scoring",
// //       content:
// //         "Automatically capture property inquiries from multiple sources—website forms, ads, social media, and calls. Our AI-powered lead scoring system prioritizes high-intent buyers based on property preferences, budget, and engagement behavior, so your agents focus on the hottest leads first.",
// //       icon: Users,
// //     },
// //     {
// //       title: "Automated Lead Nurturing",
// //       content:
// //         "Set up intelligent SMS and email sequences that nurture leads automatically. From welcome messages to property recommendations and price drop alerts, our lead management system ensures no prospect falls through the cracks. Track open rates, click-throughs, and engagement in real-time.",
// //       icon: MessageCircle,
// //     },
// //     {
// //       title: "Property Alert Automation",
// //       content:
// //         "Instantly notify your lead database the moment a new property matches their search criteria. With a 98% open rate, SMS ensures your listings are seen immediately. Our system tracks which leads engage with alerts, helping you identify serious buyers.",
// //       icon: Bell,
// //     },
// //     {
// //       title: "Viewing & Site Visit Management",
// //       content:
// //         "Minimize no-shows by 70% with automated appointment reminders. Schedule viewings, send Google Maps locations, and follow up automatically after visits. The system logs all interactions, giving you complete visibility into the buyer journey.",
// //       icon: Calendar,
// //     },
// //     {
// //       title: "Lead Distribution & Assignment",
// //       content:
// //         "Automatically assign leads to the right agents based on property type, location, or agent availability. Our smart routing ensures faster response times and better conversion rates. Track agent performance and lead response times with detailed analytics.",
// //       icon: GitMerge,
// //     },
// //     {
// //       title: "Performance Analytics & Reporting",
// //       content:
// //         "Get complete visibility into your sales pipeline with real-time dashboards. Track lead sources, conversion rates, agent performance, and ROI. Identify bottlenecks in your funnel and optimize your lead management strategy with data-driven insights.",
// //       icon: ChartColumn,
// //     },
// //   ];

// //   const lmsWorkflows = [
// //     {
// //       icon: UserCheck,
// //       title: "Lead Capture",
// //       steps: ["Website Forms", "Social Media Ads", "Phone Calls", "Walk-ins"],
// //     },
// //     {
// //       icon: Zap,
// //       title: "Automated Nurturing",
// //       steps: [
// //         "Welcome SMS",
// //         "Property Alerts",
// //         "Price Drop Updates",
// //         "Follow-up Sequences",
// //       ],
// //     },
// //     {
// //       icon: Calendar,
// //       title: "Appointment Management",
// //       steps: [
// //         "Viewing Scheduling",
// //         "Auto Reminders",
// //         "Follow-up Tasks",
// //         "Feedback Collection",
// //       ],
// //     },
// //     {
// //       icon: Rocket,
// //       title: "Conversion & Closing",
// //       steps: [
// //         "Offer Management",
// //         "Document Collection",
// //         "Payment Reminders",
// //         "Post-Sale Follow-up",
// //       ],
// //     },
// //   ];

// //   const lmsBenefits = [
// //     {
// //       icon: Clock,
// //       title: "70% Faster Response Time",
// //       desc: "Automated lead assignment ensures immediate follow-up",
// //     },
// //     {
// //       icon: TrendingUp,
// //       title: "3x Higher Conversion",
// //       desc: "AI-powered lead scoring helps prioritize hot prospects",
// //     },
// //     {
// //       icon: Users,
// //       title: "Complete Team Visibility",
// //       desc: "Track agent performance and lead activities in real-time",
// //     },
// //     {
// //       icon: BarChart3,
// //       title: "Data-Driven Decisions",
// //       desc: "Advanced analytics to optimize your sales funnel",
// //     },
// //   ];

// //   const coreFeatures = [
// //     {
// //       icon: Bell,
// //       title: "Instant Property Alerts",
// //       desc: "Notify buyers immediately when matching properties hit the market with 98% open rate SMS",
// //     },
// //     {
// //       icon: MessageCircle,
// //       title: "Automated Follow-ups",
// //       desc: "Never miss a lead with automated SMS sequences after property viewings",
// //     },
// //     {
// //       icon: Calendar,
// //       title: "Smart Scheduling",
// //       desc: "Reduce no-shows by 70% with automated viewing reminders and calendar integration",
// //     },
// //     {
// //       icon: House,
// //       title: "Lead Management",
// //       desc: "Track every lead from inquiry to closing with complete pipeline visibility",
// //     },
// //     {
// //       icon: Camera,
// //       title: "Virtual Tours",
// //       desc: "Share 360° property tours via SMS with real-time engagement tracking",
// //     },
// //     {
// //       icon: ChartColumn,
// //       title: "Analytics Dashboard",
// //       desc: "Track campaign performance and lead engagement in real-time",
// //     },
// //   ];

// //   const scrollItems = [
// //     "📱 Website Inquiry",
// //     "🏠 Property Match",
// //     "📨 Auto SMS Alert",
// //     "📞 Agent Assigned",
// //     "📍 Viewing Scheduled",
// //     "🔄 Follow-up Reminder",
// //     "💰 Offer Negotiation",
// //     "✅ Deal Closed",
// //   ];

// //   const scrollItems2 = [
// //     "📊 Lead Scored",
// //     "🎯 Hot Lead Alert",
// //     "📝 Document Request",
// //     "🏦 Payment Link",
// //     "📄 Agreement Signed",
// //     "🎉 Welcome Message",
// //     "⭐ Review Request",
// //     "🔄 Referral Program",
// //   ];

// //   return (
// //     <>
// //       <Helmet>
// //         <title>
// //           Real Estate Lead Management System | LMSBots CRM for Property Dealers
// //         </title>

// //         <meta
// //           name="description"
// //           content="Boost real estate sales with LMSBots CRM. Capture property leads, automate follow-ups, schedule site visits, and close deals faster with AI-powered lead management."
// //         />

// //         <meta
// //           name="keywords"
// //           content="real estate CRM India, property lead management system, real estate lead automation, CRM for builders, real estate sales software, LMSBots real estate"
// //         />

// //         {/* Open Graph (Social Sharing) */}
// //         <meta property="og:title" content="Real Estate CRM | LMSBots" />
// //         <meta
// //           property="og:description"
// //           content="Convert property inquiries into closed deals with LMSBots real estate lead management system."
// //         />
// //         <meta property="og:type" content="website" />
// //         <meta property="og:url" content="https://lmsbots.com/real-estate" />
// //         <meta
// //           property="og:image"
// //           content="https://lmsbots.com/images/realestate-preview.jpg"
// //         />

// //         {/* Twitter SEO */}
// //         <meta name="twitter:card" content="summary_large_image" />
// //         <meta name="twitter:title" content="Real Estate CRM | LMSBots" />
// //         <meta
// //           name="twitter:description"
// //           content="AI-powered CRM for real estate agents to capture, nurture, and close leads faster."
// //         />
// //         <meta
// //           name="twitter:image"
// //           content="https://lmsbots.com/images/realestate-preview.jpg"
// //         />

// //         {/* Canonical URL */}
// //         <link rel="canonical" href="https://lmsbots.com/real-estate" />
// //       </Helmet>
// //       <main className="font-sans antialiased overflow-x-hidden">
// //         <div className="w-full overflow-hidden">
// //           <style>{`
// //           @keyframes scroll-left {
// //             0% { transform: translateX(0); }
// //             100% { transform: translateX(-50%); }
// //           }
// //           @keyframes scroll-right {
// //             0% { transform: translateX(-50%); }
// //             100% { transform: translateX(0); }
// //           }
// //           .animate-scroll-left {
// //             display: flex;
// //             width: max-content;
// //             animation: scroll-left 40s linear infinite;
// //           }
// //           .animate-scroll-right {
// //             display: flex;
// //             width: max-content;
// //             animation: scroll-right 40s linear infinite;
// //           }
// //           .pause-on-hover:hover {
// //             animation-play-state: paused;
// //           }
// //         `}</style>

// //           {/* HERO SECTION */}

// //           <section className="bg-gradient-to-br pb-10 from-white via-indigo-50 to-purple-50 py-16 md:py-20 lg:pt-24">
// //             <div className="max-w-7xl mx-auto px-6 md:px-10 lg:px-10 flex flex-col md:flex-row items-center gap-12 lg:gap-16">
// //               {/* LEFT CONTENT */}
// //               <div className="w-full md:w-1/2 flex flex-col items-start">
// //                 <div className="inline-flex items-center gap-2 px-4 py-2 bg-indigo-100 rounded-full border border-indigo-200 mb-5">
// //                   <Zap className="w-4 h-4 text-indigo-600" />
// //                   <span className="text-xs font-semibold text-indigo-600">
// //                     Lead Management System for Real Estate
// //                   </span>
// //                 </div>

// //                 <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-slate-900 leading-tight tracking-tight mb-5 max-w-xl">
// //                   Turn Every Property Inquiry into a{" "}
// //                   <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
// //                     Closed Deal
// //                   </span>
// //                 </h1>

// //                 <p className="text-base md:text-lg text-slate-700 leading-relaxed max-w-lg">
// //                   Capture, track, and nurture real estate leads with AI-powered
// //                   automation. From first inquiry to final signature—manage your
// //                   entire sales pipeline in one powerful platform.
// //                 </p>
// //               </div>

// //               {/* RIGHT IMAGE */}
// //               <div className="w-full md:w-1/2 flex justify-center">
// //                 <img
// //                   src={RealEsatteImage}
// //                   alt="Real Estate Lead Management Dashboard"
// //                   className="w-full max-w-md md:max-w-lg lg:max-w-xl object-contain rounded shadow"
// //                 />
// //               </div>
// //             </div>
// //           </section>
// //           {/* LEAD MANAGEMENT FEATURES SECTION */}
// //           <section className="bg-gradient-to-br from-white via-indigo-50 to-purple-50 py-20 lg:py-16">
// //             <div className="container mx-auto px-6 lg:px-12">
// //               <div className="text-center max-w-4xl mx-auto mb-16">
// //                 <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-50 rounded-full border border-purple-100 mb-6">
// //                   <Settings className="w-4 h-4 text-purple-600" />
// //                   <span className="text-xs font-semibold text-purple-600">
// //                     Complete Lead Management Solution
// //                   </span>
// //                 </div>
// //                 <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 leading-tight">
// //                   How LMSBots Helps{" "}
// //                   <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
// //                     Real Estate Agencies
// //                   </span>
// //                 </h2>
// //                 <p className="text-lg text-slate-600 mt-4 max-w-2xl mx-auto">
// //                   Everything you need to capture, nurture, and convert property
// //                   leads—all in one intelligent platform
// //                 </p>
// //               </div>

// //               <div className="grid lg:grid-cols-2 pb-5 gap-8">
// //                 {leadManagementFeatures.map((feature, idx) => {
// //                   const Icon = feature.icon;
// //                   return (
// //                     <div
// //                       key={idx}
// //                       className="bg-white  rounded-2xl p-6 shadow-lg border border-slate-100 hover:shadow-xl transition-all"
// //                     >
// //                       <div className="flex items-start  gap-4">
// //                         <div className="bg-gradient-to-br from-indigo-50 to-purple-50 p-3 rounded-xl">
// //                           <Icon className="w-6 h-6 text-indigo-600" />
// //                         </div>
// //                         <div>
// //                           <h3 className="text-xl font-bold text-slate-900 mb-2">
// //                             {feature.title}
// //                           </h3>
// //                           <p className="text-slate-600 leading-relaxed">
// //                             {feature.content}
// //                           </p>
// //                         </div>
// //                       </div>
// //                     </div>
// //                   );
// //                 })}
// //               </div>
// //             </div>
// //           </section>

// //           {/* LMS WORKFLOW SECTION */}
// //           <section className="py-20 bg-white relative -mt-16">
// //             <div className="container mx-auto px-6 lg:px-12">
// //               <div className="text-center max-w-3xl mx-auto mb-16">
// //                 <span className="text-indigo-600 font-semibold text-sm uppercase tracking-wider mb-4 block">
// //                   Lead Management Workflow
// //                 </span>
// //                 <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
// //                   From{" "}
// //                   <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
// //                     Lead to Deal
// //                   </span>{" "}
// //                   in 4 Simple Steps
// //                 </h2>
// //                 <p className="text-xl text-slate-600">
// //                   Automated workflows that guide prospects through your sales
// //                   pipeline
// //                 </p>
// //               </div>

// //               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
// //                 {lmsWorkflows.map((workflow, idx) => {
// //                   const Icon = workflow.icon;
// //                   return (
// //                     <div key={idx} className="relative group">
// //                       <div className="bg-gradient-to-br from-slate-50 to-white rounded-2xl p-6 shadow-md hover:shadow-xl transition-all border border-slate-100">
// //                         <div className="bg-indigo-100 w-14 h-14 rounded-xl flex items-center justify-center mb-4 group-hover:bg-indigo-600 transition-colors">
// //                           <Icon className="w-7 h-7 text-indigo-600 group-hover:text-white transition-colors" />
// //                         </div>
// //                         <h3 className="text-xl font-bold text-slate-900 mb-4">
// //                           {workflow.title}
// //                         </h3>
// //                         <ul className="space-y-2">
// //                           {workflow.steps.map((step, i) => (
// //                             <li
// //                               key={i}
// //                               className="flex items-center gap-2 text-slate-600"
// //                             >
// //                               <CheckCircle2 className="w-4 h-4 text-indigo-500" />
// //                               <span className="text-sm">{step}</span>
// //                             </li>
// //                           ))}
// //                         </ul>
// //                       </div>
// //                     </div>
// //                   );
// //                 })}
// //               </div>
// //             </div>
// //           </section>

// //           {/* BENEFITS SECTION */}
// //           <section className="py-20 bg-gradient-to-r from-indigo-50 to-purple-50">
// //             <div className="container mx-auto px-6 lg:px-12">
// //               <div className="grid lg:grid-cols-2 gap-12 items-center">
// //                 <div>
// //                   <div className="inline-flex items-center gap-2 px-4 py-2 bg-white rounded-full border border-indigo-200 mb-6">
// //                     <TrendingUp className="w-4 h-4 text-indigo-600" />
// //                     <span className="text-xs font-semibold text-indigo-600">
// //                       Key Benefits
// //                     </span>
// //                   </div>
// //                   <h2 className="text-3xl lg:text-4xl font-bold text-slate-900 mb-4">
// //                     Why Real Estate Agencies{" "}
// //                     <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
// //                       Choose LMSBots
// //                     </span>
// //                   </h2>
// //                   <p className="text-lg text-slate-600 mb-8">
// //                     Our lead management system helps you close more deals faster
// //                     with intelligent automation and real-time insights
// //                   </p>
// //                   <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
// //                     {lmsBenefits.map((benefit, idx) => {
// //                       const Icon = benefit.icon;
// //                       return (
// //                         <div
// //                           key={idx}
// //                           className="bg-white rounded-xl p-4 shadow-sm"
// //                         >
// //                           <Icon className="w-8 h-8 text-indigo-600 mb-2" />
// //                           <h4 className="font-bold text-slate-900 mb-1">
// //                             {benefit.title}
// //                           </h4>
// //                           <p className="text-sm text-slate-600">
// //                             {benefit.desc}
// //                           </p>
// //                         </div>
// //                       );
// //                     })}
// //                   </div>
// //                 </div>
// //                 <div className="relative">
// //                   <div className="absolute -inset-4 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-3xl opacity-20 blur-2xl"></div>
// //                   <div className="relative bg-white rounded-2xl shadow-2xl overflow-hidden">
// //                     <img
// //                       src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
// //                       alt="Lead Management Dashboard"
// //                       className="w-full h-auto object-cover"
// //                     />
// //                   </div>
// //                 </div>
// //               </div>
// //             </div>
// //           </section>

// //           {/* CORE FEATURES SECTION */}
// //           <section className="py-20 bg-white">
// //             <div className="container mx-auto px-6 lg:px-12">
// //               <div className="text-center max-w-3xl mx-auto mb-16">
// //                 <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-4">
// //                   Powerful Features for{" "}
// //                   <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
// //                     Real Estate Success
// //                   </span>
// //                 </h2>
// //                 <p className="text-xl text-slate-600">
// //                   Everything you need to streamline communication and close more
// //                   deals
// //                 </p>
// //               </div>
// //               <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
// //                 {coreFeatures.map((feature, idx) => {
// //                   const Icon = feature.icon;
// //                   return (
// //                     <div
// //                       key={idx}
// //                       className="group bg-gradient-to-br from-white to-slate-50 rounded-2xl p-8 shadow-lg hover:shadow-2xl transition-all duration-500 border border-slate-100"
// //                     >
// //                       <div className="relative mb-6">
// //                         <div className="absolute inset-0 bg-indigo-600 rounded-2xl opacity-10 group-hover:opacity-20 transition-opacity duration-300 transform -rotate-6 group-hover:rotate-0"></div>
// //                         <div className="relative transform transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3">
// //                           <Icon className="w-8 h-8 text-indigo-600" />
// //                         </div>
// //                       </div>
// //                       <h3 className="text-xl font-bold text-slate-900 mb-3 group-hover:text-indigo-600 transition-colors duration-300">
// //                         {feature.title}
// //                       </h3>
// //                       <p className="text-slate-600 leading-relaxed mb-4">
// //                         {feature.desc}
// //                       </p>
// //                       <div className="absolute bottom-0 left-0 w-0 h-1 bg-indigo-600 group-hover:w-full transition-all duration-300 rounded-b-2xl"></div>
// //                     </div>
// //                   );
// //                 })}
// //               </div>
// //             </div>
// //           </section>

// //           {/* SCROLLING LEAD JOURNEY SECTION */}
// //           <section className="bg-gradient-to-br from-white via-indigo-50 to-purple-50 ">
// //             <div className="container mx-auto px-6 py-10 lg:px-12 text-center">
// //               <h2 className="text-4xl lg:text-5xl font-bold text-slate-900 mb-6 tracking-tight">
// //                 The Complete{" "}
// //                 <span className="bg-gradient-to-r from-indigo-600 to-purple-600 bg-clip-text text-transparent">
// //                   Lead Journey
// //                 </span>
// //               </h2>
// //               <p className="text-xl text-slate-500 max-w-2xl mx-auto mb-2">
// //                 See how leads move through your automated sales pipeline—from
// //                 first touch to closed deal
// //               </p>
// //               <div className="relative mt-10 mb-20 overflow-hidden">
// //                 <div className="absolute inset-y-0 left-0 w-40 z-10 bg-gradient-to-r from-[#EEF2FC] to-transparent"></div>
// //                 <div className="absolute inset-y-0 right-0 w-40 z-10 bg-gradient-to-l from-[#EEF2FC] to-transparent"></div>
// //                 <div className="animate-scroll-left gap-8 mb-5">
// //                   {scrollItems.map((item, i) => (
// //                     <div
// //                       key={i}
// //                       className="px-8 py-5 bg-white border border-slate-100 rounded-3xl text-slate-700 font-semibold text-xl whitespace-nowrap transition-all shadow-sm mx-4 cursor-default"
// //                     >
// //                       {item}
// //                     </div>
// //                   ))}
// //                 </div>
// //                 <div className="animate-scroll-right gap-8">
// //                   {scrollItems2.map((item, i) => (
// //                     <div
// //                       key={i}
// //                       className="px-8 py-5 bg-white border border-slate-100 rounded-3xl text-slate-700 font-semibold text-xl whitespace-nowrap transition-all shadow-sm mx-4 cursor-default"
// //                     >
// //                       {item}
// //                     </div>
// //                   ))}
// //                 </div>
// //               </div>
// //               <p className="text-lg lg:text-xl text-slate-600 font-normal max-w-4xl mx-auto leading-relaxed mb-16">
// //                 Automate your entire sales pipeline—from lead capture and
// //                 scoring to nurturing and closing. Get complete visibility into
// //                 every stage and watch your conversion rates soar.
// //               </p>
// //             </div>
// //           </section>
// //         </div>
// //       </main>
// //     </>
// //   );
// // };

// // export default RealEstate;








import React from "react";
import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import {
  Bell,
  MessageCircle,
  Calendar,
  Home,
  Camera,
  BarChart3,
  Users,
  TrendingUp,
  Zap,
  GitMerge,
  Settings,
  CheckCircle2,
  Clock,
  UserCheck,
  Rocket,
  ArrowRight,
  ChevronDown,
  Smartphone,
  Phone,
  MapPin,
  RefreshCw,
  Tag,
  Target,
  FileText,
  CreditCard,
  Pencil,
  Gift,
  Star,
  Building2,
  Briefcase,
} from "lucide-react";
import RealEstateImage from "../../assets/realestate.jpg";
// NOTE: adjust this path to wherever Seo.js lives in your project
import Seo, { SITE_URL } from "../../WebsiteComponents/Seo";
import { ROUTES } from "../../seoData";

const PATH = "/solutions/real-estate";
const TITLE = ROUTES[PATH].title;
const DESCRIPTION = ROUTES[PATH].description;

// ---------- Static content (outside the component so it isn't rebuilt on every render) ----------
const HERO_POINTS = ["Lead scoring", "Site-visit reminders", "Property alerts"];

const FEATURES = [
  {
    icon: Users,
    title: "Smart Lead Capture & Scoring",
    desc: "Capture property inquiries from website forms, ads, social media, and calls. Scoring weighs property preferences, budget, and engagement so agents work the hottest leads first.",
  },
  {
    icon: MessageCircle,
    title: "Automated Lead Nurturing",
    desc: "Run SMS and email sequences, from welcome messages to property recommendations and price-drop alerts. Track opens and clicks so no prospect falls through the cracks.",
  },
  {
    icon: Bell,
    title: "Property Alert Automation",
    desc: "Notify your lead database the moment a new listing matches their criteria, and see which leads engage with alerts to spot serious buyers.",
  },
  {
    icon: Calendar,
    title: "Viewing & Site Visit Management",
    desc: "Schedule viewings, send map locations, and automate reminders and post-visit follow-ups to cut no-shows. Every interaction is logged on the lead.",
  },
  {
    icon: GitMerge,
    title: "Lead Distribution & Assignment",
    desc: "Assign leads to the right agent by property type, location, or availability for faster response, and track agent performance and response times.",
  },
  {
    icon: BarChart3,
    title: "Performance Analytics & Reporting",
    desc: "Real-time dashboards for lead sources, conversion rates, agent performance, and ROI, so you can find bottlenecks in your funnel.",
  },
];

const AUDIENCE = [
  {
    icon: Home,
    title: "Real estate agencies",
    desc: "Keep every buyer, seller, and tenant inquiry with the right agent, from first call to signature.",
  },
  {
    icon: Building2,
    title: "Builders & developers",
    desc: "Manage project-wise leads, site-visit schedules, and booking follow-ups across launches.",
  },
  {
    icon: Users,
    title: "Channel partners & brokers",
    desc: "Track partner-sourced leads and see which partners and campaigns bring serious buyers.",
  },
  {
    icon: Briefcase,
    title: "Property managers & rental teams",
    desc: "Handle rental inquiries, viewings, and document collection without losing track of anyone.",
  },
];

const WORKFLOW = [
  {
    icon: UserCheck,
    title: "Lead Capture",
    steps: ["Website forms", "Social media ads", "Phone calls", "Walk-ins"],
  },
  {
    icon: Zap,
    title: "Automated Nurturing",
    steps: ["Welcome SMS", "Property alerts", "Price-drop updates", "Follow-up sequences"],
  },
  {
    icon: Calendar,
    title: "Appointment Management",
    steps: ["Viewing scheduling", "Auto reminders", "Follow-up tasks", "Feedback collection"],
  },
  {
    icon: Rocket,
    title: "Conversion & Closing",
    steps: ["Offer management", "Document collection", "Payment reminders", "Post-sale follow-up"],
  },
];

const BENEFITS = [
  {
    icon: Clock,
    title: "Faster response time",
    desc: "Automated assignment puts the right agent on a new lead right away.",
  },
  {
    icon: Target,
    title: "Better prioritization",
    desc: "Lead scoring highlights hot prospects so no time is spent on cold ones.",
  },
  {
    icon: Users,
    title: "Complete team visibility",
    desc: "Track agent performance and lead activity in real time.",
  },
  {
    icon: TrendingUp,
    title: "Data-driven decisions",
    desc: "Analytics show which sources and steps are worth your budget.",
  },
];

const CORE_FEATURES = [
  { icon: Bell, title: "Instant Property Alerts", desc: "Tell buyers right away when matching properties come on the market." },
  { icon: MessageCircle, title: "Automated Follow-ups", desc: "Automated SMS sequences after property viewings keep leads warm." },
  { icon: Calendar, title: "Smart Scheduling", desc: "Viewing reminders and calendar support help cut no-shows." },
  { icon: Home, title: "Lead Management", desc: "Track every lead from inquiry to closing with full pipeline visibility." },
  { icon: Camera, title: "Virtual Tours", desc: "Share 360° property tour links by SMS and track who opens them." },
  { icon: BarChart3, title: "Analytics Dashboard", desc: "Follow campaign performance and lead engagement in real time." },
];

const JOURNEY_1 = [
  { icon: Smartphone, label: "Website inquiry" },
  { icon: Home, label: "Property match" },
  { icon: MessageCircle, label: "Auto SMS alert" },
  { icon: Phone, label: "Agent assigned" },
  { icon: MapPin, label: "Viewing scheduled" },
  { icon: RefreshCw, label: "Follow-up reminder" },
  { icon: Tag, label: "Offer negotiation" },
  { icon: CheckCircle2, label: "Deal closed" },
];

const JOURNEY_2 = [
  { icon: BarChart3, label: "Lead scored" },
  { icon: Target, label: "Hot lead alert" },
  { icon: FileText, label: "Document request" },
  { icon: CreditCard, label: "Payment link" },
  { icon: Pencil, label: "Agreement signed" },
  { icon: Gift, label: "Welcome message" },
  { icon: Star, label: "Review request" },
  { icon: Users, label: "Referral program" },
];

const FAQS = [
  {
    q: "What is a real estate CRM?",
    a: "A real estate CRM is software that captures property inquiries from every source, assigns them to agents, automates follow-ups and site-visit reminders, and tracks each lead until the deal is closed.",
  },
  {
    q: "Which lead sources can LMSBOTS capture?",
    a: "LMSBOTS captures leads from website forms, social media and ad campaigns, phone calls, walk-ins, and partner referrals, and shows the source of every lead in one dashboard.",
  },
  {
    q: "Can it send site-visit reminders and property alerts?",
    a: "Yes. You can schedule viewing reminders with map locations, send follow-ups after visits, and notify leads by SMS or email when a new property matches what they are looking for.",
  },
  {
    q: "How are leads assigned to agents?",
    a: "Leads can be routed automatically by property type, project, location, or agent availability, and reassigned when needed. Dashboards show response times and conversion rates for every agent.",
  },
  {
    q: "Does it work for builders and channel partners?",
    a: "Yes. Builders and developers can manage project-wise leads and site visits, and channel partners and brokers can be tracked separately so you can see which partners bring serious buyers.",
  },
  {
    q: "Can my team use it on mobile?",
    a: "Yes. LMSBOTS offers a mobile app alongside the web dashboard, so agents can see new leads, log calls, and follow up on the move.",
  },
];

const JSON_LD = [
  {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "LMSBOTS Real Estate CRM",
    url: `${SITE_URL}${PATH}`,
    applicationCategory: "BusinessApplication",
    applicationSubCategory: "Real Estate CRM / Lead Management",
    operatingSystem: "Web, Android, iOS",
    description: DESCRIPTION,
    publisher: { "@id": `${SITE_URL}/#organization` },
    featureList: FEATURES.map((f) => f.title),
  },
  {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: FAQS.map(({ q, a }) => ({
      "@type": "Question",
      name: q,
      acceptedAnswer: { "@type": "Answer", text: a },
    })),
  },
  {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      { "@type": "ListItem", position: 1, name: "Home", item: SITE_URL },
      { "@type": "ListItem", position: 2, name: "Solutions", item: `${SITE_URL}/solutions` },
      { "@type": "ListItem", position: 3, name: "Real Estate", item: `${SITE_URL}${PATH}` },
    ],
  },
];

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.5, ease: "easeOut" } },
};

const stagger = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
};

// Scrolling-journey animation. Respects reduced motion: becomes a static wrapped list.
const MARQUEE_CSS = `
.re-track{display:flex;width:max-content}
@keyframes re-left{from{transform:translateX(0)}to{transform:translateX(-50%)}}
@keyframes re-right{from{transform:translateX(-50%)}to{transform:translateX(0)}}
@media (prefers-reduced-motion: no-preference){
  .re-left{animation:re-left 45s linear infinite}
  .re-right{animation:re-right 45s linear infinite}
  .re-pause:hover .re-track,.re-pause:focus-within .re-track{animation-play-state:paused}
}
@media (prefers-reduced-motion: reduce){
  .re-track{width:auto;flex-wrap:wrap;justify-content:center}
  .re-dup{display:none}
}
`;

// ---------- Plain, neutral building blocks ----------
const Pill = ({ icon: Icon, children }) => (
  <div className="mb-5 inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-1 text-xs font-medium text-slate-700 shadow-sm">
    {Icon ? <Icon className="h-3.5 w-3.5 text-[#0f9d86]" /> : <span className="h-1.5 w-1.5 rounded-full bg-[#12dfbd]" />}
    {children}
  </div>
);

const SectionHeading = ({ id, pill, icon, before, highlight, after, text }) => (
  <div className="mx-auto mb-10 max-w-3xl text-center lg:mb-14">
    <Pill icon={icon}>{pill}</Pill>
    <h2
      id={id}
      className="text-balance text-[26px] font-light leading-[1.25] tracking-tight text-[#28194f] sm:text-[34px] lg:text-[38px]"
    >
      {before} <span className="font-normal text-[#48247f]">{highlight}</span>
      {after ? ` ${after}` : ""}
    </h2>
    {text && <p className="mx-auto mt-4 max-w-[640px] text-[15px] leading-[1.75] text-slate-600 sm:text-base">{text}</p>}
    <div className="mx-auto mt-6 h-1 w-16 rounded-full bg-[#12dfbd]" />
  </div>
);

const IconTile = ({ icon: Icon, size = "md" }) => (
  <div
    className={`inline-flex flex-shrink-0 items-center justify-center rounded-xl bg-slate-100 text-slate-700 transition-colors duration-300 group-hover:bg-[#e3faf5] group-hover:text-[#0f9d86] ${
      size === "lg" ? "h-14 w-14" : "h-12 w-12"
    }`}
  >
    <Icon className={size === "lg" ? "h-7 w-7" : "h-6 w-6"} />
  </div>
);

const CARD =
  "group relative overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-all duration-300 hover:-translate-y-0.5 hover:border-slate-300 hover:shadow-md motion-reduce:transition-none motion-reduce:hover:translate-y-0";

const ACCENT_BAR =
  "absolute left-0 top-0 h-0.5 w-full origin-left scale-x-0 bg-[#12dfbd] transition-transform duration-500 ease-out group-hover:scale-x-100";

const JourneyChip = ({ icon: Icon, label, dup = false }) => (
  <li
    aria-hidden={dup ? "true" : undefined}
    className={`${dup ? "re-dup " : ""}mx-2 inline-flex flex-shrink-0 items-center gap-3 whitespace-nowrap rounded-xl border border-slate-200 bg-white px-5 py-3 text-sm font-medium text-slate-700 shadow-sm sm:text-base`}
  >
    <Icon className="h-4 w-4 text-slate-500" />
    {label}
  </li>
);

const RealEstate = () => {
  const reduced = useReducedMotion();
  const item = reduced ? undefined : fadeUp;
  const group = reduced ? undefined : stagger;
  const initial = reduced ? false : "hidden";

  return (
    <>
      <Seo title={TITLE} description={DESCRIPTION} path={PATH} jsonLd={JSON_LD} />
      <style>{MARQUEE_CSS}</style>

      <div className="w-full overflow-x-clip bg-white font-sans text-[#28194f] antialiased">
        {/* ================= HERO (plain slate surface with a faint line grid) ================= */}
        <section
          id="realestate-hero"
          aria-labelledby="realestate-heading"
          className="relative isolate w-full overflow-hidden bg-gradient-to-b from-slate-50 to-white"
        >
          <div
            className="pointer-events-none absolute inset-0 -z-10"
            style={{
              backgroundImage:
                "linear-gradient(#0f172a0d 1px, transparent 1px), linear-gradient(90deg, #0f172a0d 1px, transparent 1px)",
              backgroundSize: "44px 44px",
              WebkitMaskImage: "radial-gradient(ellipse at 30% 40%, black 20%, transparent 75%)",
              maskImage: "radial-gradient(ellipse at 30% 40%, black 20%, transparent 75%)",
            }}
          />
          <div className="pointer-events-none absolute -right-24 top-10 -z-10 h-80 w-80 rounded-full bg-[#12dfbd]/15 blur-3xl" />

          <div className="relative z-10 mx-auto grid w-full max-w-[1500px] items-center gap-10 px-4 pb-14 pt-24 sm:gap-12 sm:px-10 sm:pb-16 sm:pt-28 lg:grid-cols-2 lg:gap-14 lg:px-14 lg:pb-20 lg:pt-32 xl:px-20">
            <motion.div
              initial={initial}
              animate="visible"
              variants={group}
              className="mx-auto max-w-xl text-center lg:mx-0 lg:text-left"
            >
              <motion.div variants={item}>
                <Pill icon={Home}>Lead Management for Real Estate</Pill>
              </motion.div>

              <motion.h1
                id="realestate-heading"
                variants={item}
                className="text-balance text-[28px] font-light leading-[1.25] tracking-tight sm:text-[34px] lg:text-[38px] xl:text-[42px]"
              >
                Turn every property inquiry into a{" "}
                <span className="font-normal text-[#48247f]">closed deal</span>
              </motion.h1>

              <motion.p
                variants={item}
                className="mx-auto mt-4 max-w-[540px] text-sm font-light leading-[1.75] text-slate-600 sm:text-base lg:mx-0 lg:text-[17px]"
              >
                Capture, track, and nurture real estate leads with intelligent automation. From first
                inquiry to final signature, manage your entire sales pipeline on one platform.
              </motion.p>

              <motion.div
                variants={item}
                className="mt-8 flex flex-col items-stretch gap-3 sm:flex-row sm:flex-wrap sm:items-center sm:justify-center lg:justify-start lg:gap-4"
              >
                <Link
                  to="/contact"
                  className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-[#12dfbd] px-6 py-3 text-xs font-semibold text-[#102b37] shadow-lg shadow-[#12dfbd]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#40f0d3] hover:shadow-[#12dfbd]/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#28194f] focus-visible:ring-offset-2 sm:text-sm"
                >
                  Request a Demo
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
                <Link
                  to="/features"
                  className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-slate-300 bg-white px-6 py-3 text-xs font-medium text-slate-700 shadow-sm transition-all duration-300 hover:border-slate-400 hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#28194f] focus-visible:ring-offset-2 sm:text-sm"
                >
                  Explore Features
                </Link>
              </motion.div>

              <motion.ul
                variants={item}
                className="mt-8 flex flex-wrap items-center justify-center gap-x-5 gap-y-2.5 lg:justify-start"
              >
                {HERO_POINTS.map((p) => (
                  <li key={p} className="inline-flex items-center gap-2 text-xs font-medium text-slate-700 sm:text-sm">
                    <CheckCircle2 className="h-4 w-4 text-[#0f9d86]" strokeWidth={2.5} />
                    {p}
                  </li>
                ))}
              </motion.ul>
            </motion.div>

            <motion.div
              initial={reduced ? false : { opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7, ease: "easeOut" }}
              className="relative mx-auto w-full max-w-[600px] px-3 pb-6 pt-3 lg:max-w-none"
            >
              {/* Plain tinted block sits below the image */}
              <div className="absolute inset-x-8 bottom-0 top-10 rounded-3xl bg-[#e3faf5]" />
              <div className="relative rounded-2xl bg-white p-2 shadow-xl ring-1 ring-slate-200">
                <img
                  src={RealEstateImage}
                  alt="LMSBOTS real estate CRM dashboard showing property leads, site visits and agent assignments"
                  width="1200"
                  height="800"
                  fetchpriority="high"
                  decoding="async"
                  className="h-auto w-full rounded-xl border border-slate-200 object-cover"
                />
              </div>
            </motion.div>
          </div>
        </section>

        {/* ================= FEATURES ================= */}
        <section
          id="realestate-features"
          aria-labelledby="realestate-features-heading"
          className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="realestate-features-heading"
              pill="Complete Lead Management Solution"
              icon={Settings}
              before="How LMSBOTS helps"
              highlight="real estate agencies"
              text="Everything you need to capture, nurture, and convert property leads, all in one platform."
            />

            <motion.ul
              variants={group}
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6"
            >
              {FEATURES.map((f) => (
                <motion.li key={f.title} variants={item} className={`${CARD} p-6`}>
                  <div className={ACCENT_BAR} />
                  <div className="mb-4">
                    <IconTile icon={f.icon} />
                  </div>
                  <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{f.title}</h3>
                  <p className="text-sm leading-[1.75] text-slate-600">{f.desc}</p>
                </motion.li>
              ))}
            </motion.ul>
          </div>
        </section>

        {/* ================= WHO IT'S FOR ================= */}
        <section
          id="realestate-audience"
          aria-labelledby="realestate-audience-heading"
          className="relative w-full border-y border-slate-200 bg-slate-50 py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="realestate-audience-heading"
              pill="Who It's For"
              icon={Users}
              before="Built for every"
              highlight="property sales team"
              text="From independent agents to large developers, LMSBOTS adapts to how you find and close buyers."
            />

            <motion.ul
              variants={group}
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6"
            >
              {AUDIENCE.map((a) => (
                <motion.li key={a.title} variants={item} className={`${CARD} p-6`}>
                  <div className={ACCENT_BAR} />
                  <div className="mb-4">
                    <IconTile icon={a.icon} />
                  </div>
                  <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{a.title}</h3>
                  <p className="text-sm leading-[1.7] text-slate-600">{a.desc}</p>
                </motion.li>
              ))}
            </motion.ul>
          </div>
        </section>

        {/* ================= WORKFLOW (simple plain diagram) ================= */}
        <section
          id="realestate-workflow"
          aria-labelledby="realestate-workflow-heading"
          className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="realestate-workflow-heading"
              pill="Lead Management Workflow"
              icon={RefreshCw}
              before="From"
              highlight="lead to deal"
              after="in 4 simple steps"
              text="Automated workflows that guide prospects through your sales pipeline."
            />

            <ol className="relative grid grid-cols-1 gap-8 md:grid-cols-4 md:gap-6">
              {/* Horizontal connector (desktop) */}
              <div
                aria-hidden="true"
                className="absolute left-[12.5%] right-[12.5%] top-6 hidden h-px bg-slate-300 md:block"
              />

              {WORKFLOW.map((w, i) => {
                const Icon = w.icon;
                const last = i === WORKFLOW.length - 1;
                return (
                  <li key={w.title} className="relative flex gap-4 md:flex-col md:items-center md:gap-5 md:text-center">
                    {/* Vertical connector (mobile) */}
                    {!last && (
                      <div
                        aria-hidden="true"
                        className="absolute left-6 top-12 -bottom-8 w-px -translate-x-1/2 bg-slate-300 md:hidden"
                      />
                    )}

                    {/* Node */}
                    <div className="relative z-10 flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full border border-slate-300 bg-white text-slate-700">
                      <Icon className="h-5 w-5" />
                      <span className="absolute -right-1.5 -top-1.5 flex h-5 w-5 items-center justify-center rounded-full bg-slate-800 text-[11px] font-semibold text-white">
                        {i + 1}
                      </span>
                    </div>

                    {/* Content */}
                    <div className="min-w-0 pb-2">
                      <h3 className="mb-3 text-lg font-medium tracking-tight text-[#28194f]">{w.title}</h3>
                      <ul className="space-y-1.5 text-sm text-slate-600">
                        {w.steps.map((s) => (
                          <li key={s} className="flex items-center gap-2 md:justify-center">
                            <span aria-hidden="true" className="h-1 w-1 flex-shrink-0 rounded-full bg-slate-400" />
                            {s}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </li>
                );
              })}
            </ol>
          </div>
        </section>

        {/* ================= BENEFITS ================= */}
        <section
          id="realestate-benefits"
          aria-labelledby="realestate-benefits-heading"
          className="relative w-full border-y border-slate-200 bg-slate-50 py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="realestate-benefits-heading"
              pill="Key Benefits"
              icon={TrendingUp}
              before="Why real estate agencies choose"
              highlight="LMSBOTS"
              text="Close more deals faster with intelligent automation and real-time insights."
            />

            <motion.ul
              variants={group}
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 lg:gap-6"
            >
              {BENEFITS.map((b) => (
                <motion.li key={b.title} variants={item} className={`${CARD} p-6`}>
                  <div className={ACCENT_BAR} />
                  <div className="mb-4">
                    <IconTile icon={b.icon} />
                  </div>
                  <h3 className="mb-2 text-lg font-medium tracking-tight text-[#28194f]">{b.title}</h3>
                  <p className="text-sm leading-[1.7] text-slate-600">{b.desc}</p>
                </motion.li>
              ))}
            </motion.ul>
          </div>
        </section>

        {/* ================= CORE FEATURES ================= */}
        <section
          id="realestate-core"
          aria-labelledby="realestate-core-heading"
          className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="realestate-core-heading"
              pill="Core Capabilities"
              before="Powerful features for"
              highlight="real estate success"
              text="Everything you need to streamline communication and close more deals."
            />

            <motion.ul
              variants={group}
              initial={initial}
              whileInView="visible"
              viewport={{ once: true, margin: "-80px" }}
              className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3 lg:gap-6"
            >
              {CORE_FEATURES.map((f) => (
                <motion.li key={f.title} variants={item} className={`${CARD} flex items-start gap-4 p-6`}>
                  <div className={ACCENT_BAR} />
                  <IconTile icon={f.icon} />
                  <div className="min-w-0">
                    <h3 className="mb-1.5 text-lg font-medium tracking-tight text-[#28194f]">{f.title}</h3>
                    <p className="text-sm leading-[1.7] text-slate-600">{f.desc}</p>
                  </div>
                </motion.li>
              ))}
            </motion.ul>
          </div>
        </section>

        {/* ================= LEAD JOURNEY (plain strip) ================= */}
        <section
          id="realestate-journey"
          aria-labelledby="realestate-journey-heading"
          className="relative w-full overflow-hidden border-t border-slate-200 bg-slate-50 py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[1300px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="realestate-journey-heading"
              pill="Lead Journey"
              before="The complete"
              highlight="lead journey"
              text="See how leads move through your automated sales pipeline, from first touch to closed deal."
            />
          </div>

          <div className="re-pause relative space-y-4" role="group" aria-label="Examples of stages in the real estate lead journey">
            <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-16 bg-gradient-to-r from-slate-50 to-transparent sm:w-32" />
            <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-16 bg-gradient-to-l from-slate-50 to-transparent sm:w-32" />

            {[
              { list: JOURNEY_1, dir: "re-left" },
              { list: JOURNEY_2, dir: "re-right" },
            ].map(({ list, dir }) => (
              <div key={dir} className="overflow-hidden">
                <ul className={`re-track ${dir}`}>
                  {list.map((j) => (
                    <JourneyChip key={j.label} {...j} />
                  ))}
                  {/* Duplicate set makes the loop seamless; hidden from assistive tech and reduced-motion users */}
                  {list.map((j) => (
                    <JourneyChip key={`dup-${j.label}`} dup {...j} />
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <p className="mx-auto mt-10 max-w-3xl px-4 text-center text-[15px] leading-[1.75] text-slate-600 sm:px-10 sm:text-base">
            Automate your sales pipeline from lead capture and scoring to nurturing and closing, with
            complete visibility into every stage.
          </p>
        </section>

        {/* ================= FAQ ================= */}
        <section
          id="realestate-faq"
          aria-labelledby="realestate-faq-heading"
          className="relative w-full bg-white py-14 sm:py-16 lg:py-24"
        >
          <div className="mx-auto w-full max-w-[900px] px-4 sm:px-10 lg:px-14">
            <SectionHeading
              id="realestate-faq-heading"
              pill="FAQ"
              before="Real estate CRM"
              highlight="questions answered"
            />

            <div className="space-y-3">
              {FAQS.map(({ q, a }, i) => (
                <details
                  key={q}
                  open={i === 0}
                  className="group overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-sm transition-colors open:border-slate-300"
                >
                  <summary className="flex min-h-[64px] cursor-pointer list-none items-center justify-between gap-4 px-5 py-4 text-left focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-[#28194f] sm:px-6 [&::-webkit-details-marker]:hidden">
                    <h3 className="flex-1 text-[15px] font-medium leading-snug text-[#28194f] sm:text-base">{q}</h3>
                    <span className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-slate-100 text-slate-700 transition-all duration-300 group-open:rotate-180 group-open:bg-[#e3faf5] group-open:text-[#0f9d86]">
                      <ChevronDown className="h-5 w-5" />
                    </span>
                  </summary>
                  <p className="px-5 pb-6 text-sm leading-[1.75] text-slate-600 sm:px-6 sm:text-[15px]">{a}</p>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* ================= CLOSING CTA ================= */}
        <section
          aria-labelledby="realestate-cta-heading"
          className="w-full bg-white px-4 pb-10 sm:px-10 sm:pb-12 lg:px-14 lg:pb-16"
        >
          <div className="mx-auto w-full max-w-[1300px] rounded-[1.5rem] border border-slate-200 bg-slate-50 px-5 py-12 text-center sm:rounded-[2rem] sm:px-12 sm:py-16">
            <h2
              id="realestate-cta-heading"
              className="mx-auto max-w-2xl text-balance text-[26px] font-light leading-[1.25] tracking-tight sm:text-[34px]"
            >
              Ready to <span className="font-normal text-[#48247f]">close more deals?</span>
            </h2>
            <p className="mx-auto mt-4 max-w-[560px] text-[15px] leading-[1.75] text-slate-600 sm:text-base">
              See how LMSBOTS fits your sales process. In a live demo we'll cover lead capture, agent
              assignment, site-visit reminders, follow-ups, and reporting.
            </p>
            <div className="mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center">
              <Link
                to="/contact"
                className="group inline-flex min-h-[44px] items-center justify-center gap-2 rounded-lg bg-[#12dfbd] px-7 py-3 text-xs font-semibold text-[#102b37] shadow-lg shadow-[#12dfbd]/20 transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#40f0d3] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#28194f] focus-visible:ring-offset-2 sm:text-sm"
              >
                Request a Demo
                <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
              </Link>
              <Link
                to="/pricing"
                className="inline-flex min-h-[44px] items-center justify-center rounded-lg border border-slate-300 bg-white px-7 py-3 text-xs font-medium text-slate-700 shadow-sm transition-all duration-300 hover:border-slate-400 hover:bg-slate-50 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#28194f] focus-visible:ring-offset-2 sm:text-sm"
              >
                View Pricing
              </Link>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default RealEstate;